import { Button, CircularProgress, Grid, IconButton, InputAdornment, TextField, Tooltip } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Router, { useRouter } from 'next/router';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getUuidByString from 'uuid-by-string';
import ApiService from '../../api/restApi';
import { fetchHeadingAndUrl, _RESOLUTION_ENTITY_TYPE } from '../../utility/common';
import { buildCmsPageUrl, fetchAIBasedContent } from '../../utility/cr-common';
import MagicIcon from '../MagicIcon';
import { CREATE_NEW_PAGE_USING, DEFAULT_COUNTRY_LANGAUGE } from '../../constants/content-recommendations';
import { useCustomerInfo, useIsTestDriveUser, useQalert, useTestDriveDomain } from '../../utility/services/customHooks';
import { getHostNameList, validateUrlWithDomains } from '../../utility/validation/urls';

import { Autocomplete } from '@material-ui/lab';
import { isEmpty, isUndefined, uniqBy } from 'lodash';
import { sortDomainOptions } from '../../utility/domainDropdownSort';
import { actionTypes } from '../../constants/actionTypes';
import { COMPONENT_NAMES, SCREEN_NAMES, trackAnalyticsEvent } from '../../constants/analyticsMeta';
import { getCountryDetailsByAlpfa2 } from '../../constants/CountryAndLanguages';
import { FormAutoComplete, FormDropDown } from '../formElements';
import { typeAny } from './Content-Brief/contentBriefType';
import { getCRDetailPagePath, getPageDraftDetailPagePath } from '../../utility/services/crListHelper';
import { dispatchMasterDataQuery } from '../../utility/services/api/common';
import { ANNOTATION_SUB_TYPE_VALUE, ANNOTATION_TYPE } from '../../constants/formMeta/recommendation';
import { useUser } from '@auth0/nextjs-auth0/client';
import { format } from 'date-fns';
import CustomAlert from '../shared/CustomAlert';
import IfComponent from '../shared/IfComponent';
const DEFAULT_FOLDERS = ['/', '/blog/', '/resources/', '/guides/'];
const FOLDER_STORAGE_KEY = 'qttr::pageDraftCustomFolders';

type propsType = {
  creatingPageFrom: string;
  setShowCreateNewPagePopUp: (params: boolean) => void;
  language_country_details?: typeof DEFAULT_COUNTRY_LANGAUGE;
  copyExistingPageData?: {
    pageId: string;
    pageUrl: string;
    selectedRowDataForPageCreation?: typeAny[];
    selectedSubKeywordsMapping?: { [key: string]: string[] };
    isSelectedKeywordClustersAllProcessed: boolean;
  };
  discoveredKeywords?: string[] | undefined;
  redirectToNewTab?: boolean;
  initialPageType?: 'article' | 'landing_page';
};

interface typeCountryData {
  alpha_2: string;
  alpha_3: string;
  text: string;
  name: string;
  value: string;
}

const DEFAULT_COUNTRY: typeCountryData = {
  name: 'United States of America',
  text: 'United States of America',
  value: 'United States of America',
  alpha_3: 'USA',
  alpha_2: 'US',
};
interface typeLanguageData {
  language_code: string;
  // language_name: string;
  location_code: string | number | null;
  text: string;
  name: string;
  value: string;
}

const DEFAULT_LANGUAGE: typeLanguageData = {
  name: 'English',
  text: 'English',
  value: 'English',
  language_code: 'en',
  location_code: '2840',
};

type DropDownOption = {
  text: string;
  value: string;
  name: string;
};
interface Payload {
  label: string;
  customer_url: string;
  component_name: string;
  screen_name: string;
  step_name?: string; // Optional property
}

const CreateNewPageFromExistingPage: React.FunctionComponent<propsType> = ({
  creatingPageFrom,
  setShowCreateNewPagePopUp,
  language_country_details = { ...DEFAULT_COUNTRY_LANGAUGE },
  copyExistingPageData,
  discoveredKeywords,
  redirectToNewTab = false,
  initialPageType,
}) => {
  const [pageType, setPageType] = useState<'article' | 'landing_page'>(initialPageType || 'article');
  const [countryDataList, setCountryDataList] = useState<typeCountryData[]>([]);
  const [languageDataList, setLanguageDataList] = useState<typeLanguageData[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState<typeLanguageData | undefined>();
  const [newPageUrl, setNewPageUrl] = useState('');
  const [selectedCountry, setSelectedCountry] = useState<typeCountryData | undefined>();
  const [heading, setHeading] = useState('');
  const [domainsList, setDomainsList] = useState<string[]>([]);
  // eslint-disable-next-line
  const [existingPageData, setExistingPageData] = useState<any | null>(null);
  const [isFromGrowthTrends, setIsFromGrowthTrends] = useState(false);
  const [validUrlError, setValidUrlError] = useState('');
  const [validLiveUrl, setValidLiveUrl] = useState('');
  const { user } = useUser();
  const [headingError, setHeadingError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [languageError, setLanguageError] = useState('');
  const [editorError, setEditorError] = useState('');
  const [keywordsError, setKeywordsError] = useState('');
  const [keywords, setKeywords] = useState<string[]>(discoveredKeywords || []);
  const [keywordsInputValue, setInputValue] = useState('');

  const [isApiInProcess, setIsApiInProcess] = useState(false);
  const [isGeneratingSlug, setIsGeneratingSlug] = useState(false);
  const masterLanguageAndCountry: { countryData: any[]; languageData: any[] } | object = useSelector(
    (state) => state.root.masterLanguageAndCountry
  );
  const contentBriefList = useSelector((state) => state.root.contentBriefList);
  const [domainAutocompleteList, setDomainAutocompleteList] = useState<DropDownOption[] | undefined>();
  const [selectedDomain, setSelectedDomain] = useState('');
  const [selectedFolder, setSelectedFolder] = useState('/');
  const [pastedDomainNotFound, setPastedDomainNotFound] = useState(false);
  const [customFolders, setCustomFolders] = useState<string[]>(() => {
    try {
      if (typeof window === 'undefined') return [];
      const stored = window.localStorage.getItem(FOLDER_STORAGE_KEY);
      if (!stored) return [];
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.filter((v) => typeof v === 'string') : [];
    } catch {
      return [];
    }
  });
  const [isAddFolderDialogOpen, setIsAddFolderDialogOpen] = useState(false);
  const [newFolderInput, setNewFolderInput] = useState('');
  const [addFolderError, setAddFolderError] = useState('');
  const newFolderInputRef = useRef<HTMLInputElement | null>(null);
  const [slugManuallyEdited, setSlugManuallyEdited] = useState(false);
  const [showCustomAlert, setShowCustomAlert] = useState(true);

  const [, toggleSnackBar] = useQalert();
  const dispatch = useDispatch();

  const customerInfo = useSelector((state) => state.root.customerInfo) || [];
  const custDetails = useCustomerInfo(customerInfo) as { cust_code?: string; domain_url?: string };

  interface SupportedEditor {
    value: string;
    label: string;
  }
  interface CMSDetailsEnv {
    supportedEditors?: SupportedEditor[];
    supportedPostTypes?: SupportedEditor[];
    pagesPath?: string;
    editorType?: string;
  }
  const [cmsDetails, setCmsDetails] = useState<Record<string, CMSDetailsEnv> | null>(null);

  // Fetch customer-info with fetchCMSDetails param using custDetails.cust_code
  useEffect(() => {
    const fetchCmsDetails = async () => {
      try {
        const response = await ApiService.get<{
          data: { cust_code: string; cms_details?: Record<string, CMSDetailsEnv> }[];
        }>(`${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/customer-info`, { params: { fetchCMSDetails: true } });
        if (response?.data) {
          const currentCustomer = response.data.find((c) => c.cust_code === custDetails?.cust_code);
          if (currentCustomer?.cms_details) {
            setCmsDetails(currentCustomer.cms_details);
          }
        }
      } catch (error) {
        console.error('Failed to fetch CMS details:', error);
      }
    };
    if (custDetails?.cust_code) {
      fetchCmsDetails();
    }
  }, [custDetails?.cust_code]);

  const isTestDriveUser = useIsTestDriveUser();
  const testDriveDomain = useTestDriveDomain();
  const supportedEditorList = useMemo(() => {
    const env = process.env.NEXT_PUBLIC_APP_ENV || 'production';
    const editors = cmsDetails?.[env]?.supportedEditors;
    return editors?.map((i) => ({ ...i, text: i.label })) || [];
  }, [cmsDetails]);

  const pagesPath = useMemo(() => {
    const env = process.env.NEXT_PUBLIC_APP_ENV || 'production';
    return cmsDetails?.[env]?.pagesPath || '';
  }, [cmsDetails]);

  const cmsEditorType = useMemo(() => {
    const env = process.env.NEXT_PUBLIC_APP_ENV || 'production';
    return cmsDetails?.[env]?.editorType?.toUpperCase() || '';
  }, [cmsDetails]);

  const supportedPostTypeList = useMemo(() => {
    const env = process.env.NEXT_PUBLIC_APP_ENV || 'production';
    const postTypes = cmsDetails?.[env]?.supportedPostTypes;
    return postTypes?.map((i) => ({ ...i, text: i.label })) || [];
  }, [cmsDetails]);

  const [selectedEditorType, setSelectedEditorType] = useState('');
  const [selectedWpPostType, setSelectedWpPostType] = useState('post');

  // Post type dropdown: only for articles when customer has 2+ post types
  const showPostTypeDropdown = supportedPostTypeList?.length >= 2 && pageType?.toLowerCase() === 'article';

  // Hide editor dropdown when PSEO selected (always Gutenberg)
  const isPseoSelected = selectedWpPostType && selectedWpPostType !== 'post' && selectedWpPostType !== 'page';
  const showEditorDropdown = supportedEditorList?.length >= 2 && !isPseoSelected;

  // Auto-set editor type based on post type and CMS config
  useEffect(() => {
    if (isPseoSelected) {
      setSelectedEditorType('GUTENBERG');
      return;
    }
    if (showEditorDropdown) return;
    if (cmsEditorType) {
      setSelectedEditorType(cmsEditorType);
    } else {
      setSelectedEditorType('TINYMCE');
    }
  }, [cmsEditorType, showEditorDropdown, isPseoSelected]);

  const router = useRouter();

  const getLanguageAndCountryData = useCallback(async () => {
    try {
      const response: { data: any[] } = await ApiService.get(
        `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/master-data/country-language`
      );
      dispatch({
        type: actionTypes.MASTER_COUNTRY_AND_LANGUAGE,
        payload: response.data,
      });
    } catch (error) {
      toggleSnackBar({ type: 'error', text: 'Oops! Something Went Wrong. Please try again.', open: true });
      setShowCreateNewPagePopUp(false);
    }
  }, [dispatch, setShowCreateNewPagePopUp, toggleSnackBar]);

  const fetchDomains = useCallback(
    async (
      domainUrl: string | undefined,
      testDriveDomain: string | undefined,
      isTestDriveUser: boolean | undefined
    ) => {
      try {
        // if it's a test drive, we already have the information in the session
        if (isTestDriveUser) {
          if (testDriveDomain) {
            const domainAutoComplete = [
              {
                value: new URL(testDriveDomain).origin,
                name: testDriveDomain.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
                text: testDriveDomain.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
              },
            ];
            setDomainAutocompleteList(domainAutoComplete);
            setDomainsList([testDriveDomain]);
            setSelectedDomain(domainAutoComplete ? domainAutoComplete[0]?.value || '' : '');
          } else {
            // test drive domain not loaded yet
            setDomainsList([]);
          }
          return;
        }

        // otherwise, for non-test drive users...
        setIsApiInProcess(true);

        const promiseArray = [
          dispatchMasterDataQuery(dispatch, ['domain', 'market_share_segment']),
          ApiService.get(`${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/settings/setup?type=domain`),
        ];

        const [masterDomainResponse, domainSetupResponse] = await Promise.all(promiseArray);

        const allDomains: string[] = [
          ...(getHostNameList(domainSetupResponse?.data?.domainSetup?.SUPPORTED_DOMAINS, 'origin') || ([] as string[])),
        ];

        const domainSetupTextValueMap =
          allDomains?.map((domain) => {
            return {
              value: new URL(domain)?.origin,
              name: domain?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
              text: domain?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
            };
          }) || [];

        const allAutoCompleteDomainList: { text: string; name: string; value: string }[] = [];
        if (masterDomainResponse?.domain?.length) {
          masterDomainResponse?.domain?.forEach((domain) => {
            allDomains.push(new URL(domain?.top_data)?.origin);
            allAutoCompleteDomainList.push({
              value: new URL(domain?.top_data)?.origin,
              name: domain?.top_data.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
              text: domain?.top_data.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
            });
          });
          setSelectedDomain(allAutoCompleteDomainList ? allAutoCompleteDomainList[0]?.value || '' : '');
        } else {
          if (domainUrl) {
            allDomains.push(new URL(domainUrl)?.origin);
            allAutoCompleteDomainList.push({
              value: new URL(domainUrl)?.origin,
              name: domainUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
              text: domainUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').replace(/\/$/, ''),
            });
            setSelectedDomain(allAutoCompleteDomainList ? allAutoCompleteDomainList[0]?.value || '' : '');
          }
        }
        setDomainAutocompleteList([...allAutoCompleteDomainList, ...domainSetupTextValueMap]);
        setDomainsList(allDomains);
      } catch (error) {
        console.error('CreateNewPage:: fetchDomains::error::', error);
      } finally {
        setIsApiInProcess(false);
      }
    },
    []
  );

  const fetchRequiredData = useCallback(
    async (
      domainUrl: string | undefined,
      testDriveDomain: string | undefined,
      isTestDriveUser: boolean | undefined
    ) => {
      setIsApiInProcess(true);
      try {
        const promiseArray = [fetchDomains(domainUrl, testDriveDomain, isTestDriveUser)];
        if (isEmpty(masterLanguageAndCountry)) {
          promiseArray.push(getLanguageAndCountryData());
        }
        await Promise.all(promiseArray);
      } catch (error) {
        console.error('CreateNewPage::fetchRequiredData::error::', error);
      } finally {
        setIsApiInProcess(false);
      }
    },
    [fetchDomains, getLanguageAndCountryData, masterLanguageAndCountry]
  );

  const cancelHandler = () => {
    setShowCreateNewPagePopUp(false);
    trackAnalyticsEvent({
      eventFor: '',
      buttonText: '',
      eventName: 'Create New Page Form Cancel',
      payload: {
        label: 'Create New Page Form Cancel',
        component_name: COMPONENT_NAMES.content_recommendations,
        screen_name: SCREEN_NAMES.content_recommendations,
      },
    });
  };

  const onResetSlugErrors = useCallback(() => {
    setValidUrlError('');
    setValidLiveUrl('');
    setExistingPageData(null);
  }, []);

  const slugifyHeading = useCallback((value: string): string => {
    return value
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 60);
  }, []);

  // Slug normalization for SEO-safe URLs. Allowed character set:
  //   - lowercase letters a-z
  //   - digits 0-9
  //   - hyphen "-" (word separator)
  //   - slash "/" (subpath separator, e.g. "2024/article")
  //   - underscore "_" (less common but valid)
  // Everything else (#, ?, %, !, ^, accented chars, emoji, ...) is stripped.
  // Whitespace runs become a single hyphen; runs of hyphens collapse to one.
  const normalizeSlugInput = useCallback((raw: string): string => {
    return raw
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-/_]/g, '')
      .replace(/-+/g, '-');
  }, []);

  // Split a path-like seed (e.g. "blog/ai-keyword-research") into the
  // folder + slug parts the modal expects, so the Folder dropdown picks
  // up the prefix instead of the whole thing landing in the slug field.
  const splitInitialPageUrl = useCallback((rawPageUrl: string): { folder: string; slug: string } => {
    if (!rawPageUrl) return { folder: '/', slug: '' };
    const cleaned = rawPageUrl.replace(/^\/+/, '');
    const parts = cleaned.split('/').filter(Boolean);
    if (parts.length > 1) {
      return { folder: '/' + parts[0] + '/', slug: parts.slice(1).join('/') };
    }
    return { folder: '/', slug: parts[0] || '' };
  }, []);

  const knownFolderValues = useMemo(() => {
    const fromExisting: string[] = [];
    (contentBriefList || []).forEach((item) => {
      try {
        const url = item?.finalurl || item?.page || '';
        if (!url) return;
        const pathname = new URL(url).pathname;
        const parts = pathname.split('/').filter(Boolean);
        if (parts.length > 1) {
          fromExisting.push('/' + parts[0] + '/');
        }
      } catch {
        // ignore malformed URLs
      }
    });
    return new Set<string>([...fromExisting, ...DEFAULT_FOLDERS, ...customFolders]);
  }, [contentBriefList, customFolders]);

  const autoSelectDomainAndSlugHandler = useCallback(
    (urlValue: string) => {
      const normalizeOrigin = (s: string) =>
        (s || '')
          .toLowerCase()
          .replace(/^https?:\/\//, '')
          .replace(/^www\./, '')
          .replace(/\/+$/, '');
      const trimmed = (urlValue || '').trim();
      let url: URL | null = null;
      // First try parsing as-is. If the user typed a protocol, trust the parser.
      try {
        url = new URL(trimmed);
      } catch {
        // not a full URL; will try with https:// prefix below
      }
      // For bare input, require a TLD-like or IP-shaped pattern before assuming
      // it's a domain. Prevents plain-text pastes like "my-slug" from being
      // treated as a hostname.
      if (!url) {
        const looksDomainish =
          /^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}/i.test(trimmed) || /^\d{1,3}(\.\d{1,3}){3}/.test(trimmed);
        if (looksDomainish) {
          try {
            url = new URL('https://' + trimmed);
          } catch {
            // genuinely not URL-shaped
          }
        }
      }
      if (url) {
        const newOrigin = url.origin;
        const pathname = url.pathname || '';
        const parts = pathname.split('/').filter(Boolean);
        const pathHadTrailingSlash = pathname.length > 1 && pathname.endsWith('/');
        let folder = '/';
        let slugPart = '';
        if (parts.length > 1) {
          folder = '/' + parts[0].toLowerCase() + '/';
          slugPart = parts.slice(1).join('/');
          // Auto-persist a folder learned from the pasted URL so it stays
          // in the Folder dropdown across modal sessions.
          if (!knownFolderValues.has(folder)) {
            setCustomFolders((prev) => {
              if (prev.includes(folder)) return prev;
              const next = [...prev, folder];
              try {
                if (typeof window !== 'undefined') {
                  window.localStorage.setItem(FOLDER_STORAGE_KEY, JSON.stringify(next));
                }
              } catch {
                // ignore (private mode, quota exceeded, etc.)
              }
              return next;
            });
          }
        } else if (parts.length === 1) {
          slugPart = parts[0];
        }
        // Discard query string and fragment — only the pathname belongs in the slug.
        // Tracking params (e.g. utm_source) and section anchors (#about) are transient
        // and would corrupt the canonical page URL + duplicate-detection.
        slugPart = slugPart?.startsWith('/') ? slugPart?.slice(1) : slugPart;
        if (pathHadTrailingSlash && slugPart && !slugPart.endsWith('/')) {
          slugPart = slugPart + '/';
        }
        // URL parser preserves case + may include encoded chars in the pathname;
        // run through normalizeSlugInput so the saved slug stays SEO-safe.
        setNewPageUrl(normalizeSlugInput(slugPart || ''));
        setSelectedFolder(folder);
        setSlugManuallyEdited(true);
        const targetOrigin = normalizeOrigin(newOrigin);
        const findDomain = domainAutocompleteList?.find((domain) => normalizeOrigin(domain?.value) === targetOrigin);
        if (findDomain) {
          setSelectedDomain(findDomain?.value);
          setPastedDomainNotFound(false);
        } else {
          setSelectedDomain('');
          setPastedDomainNotFound(true);
        }
      } else {
        const newUrl = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;
        setNewPageUrl(normalizeSlugInput(newUrl));
        setSlugManuallyEdited(true);
        setPastedDomainNotFound(false);
      }
    },
    [domainAutocompleteList, knownFolderValues, normalizeSlugInput]
  );

  const handleSlugPaste = useCallback(
    (e: React.ClipboardEvent<HTMLInputElement>) => {
      onResetSlugErrors();
      e.preventDefault();
      const pastedText = e.clipboardData.getData('text');
      autoSelectDomainAndSlugHandler(pastedText);
    },
    [onResetSlugErrors, autoSelectDomainAndSlugHandler]
  );

  const folderOptions = useMemo(() => {
    const all = Array.from(new Set([...knownFolderValues, selectedFolder || '/']));
    const sorted = all.sort().map((f) => ({ name: f, text: f, value: f }));
    sorted.push({ name: '__add_new_folder__', text: '+ Add New Folder', value: '__add_new_folder__' });
    return sorted;
  }, [knownFolderValues, selectedFolder]);

  const normalizeFolderInput = useCallback((raw: string): string => {
    let n = raw.trim().toLowerCase();
    n = n.replace(/^https?:\/\/[^/]+/, '');
    n = n.replace(/[^a-z0-9/_-]/g, '');
    n = n.replace(/\/+/g, '/');
    if (!n.startsWith('/')) n = '/' + n;
    if (!n.endsWith('/')) n = n + '/';
    return n;
  }, []);

  const handleAddNewFolder = useCallback(() => {
    const normalized = normalizeFolderInput(newFolderInput);
    if (normalized === '/' || normalized.length < 2) {
      setAddFolderError('Please enter a valid folder name');
      return;
    }
    setCustomFolders((prev) => {
      if (prev.includes(normalized)) return prev;
      const next = [...prev, normalized];
      try {
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(FOLDER_STORAGE_KEY, JSON.stringify(next));
        }
      } catch {
        // ignore (private mode, quota exceeded, etc.)
      }
      return next;
    });
    setSelectedFolder(normalized);
    setIsAddFolderDialogOpen(false);
    setNewFolderInput('');
    setAddFolderError('');
  }, [newFolderInput, normalizeFolderInput]);

  useEffect(() => {
    if (!isAddFolderDialogOpen) return;
    const t = setTimeout(() => {
      newFolderInputRef.current?.focus();
    }, 50);
    return () => clearTimeout(t);
  }, [isAddFolderDialogOpen]);

  const fullUrlPreview = useMemo(() => {
    if (!selectedDomain) return '';
    const base = selectedDomain.replace(/\/+$/, '');
    const folder = (selectedFolder || '/').replace(/^\/+|\/+$/g, '');
    // Preserve a single trailing slash on the slug; collapse internal "//"
    const slug = (newPageUrl || '').replace(/^\/+/, '').replace(/\/{2,}/g, '/');
    if (!folder && !slug) return base + '/';
    if (!folder) return base + '/' + slug;
    if (!slug) return base + '/' + folder + '/';
    return base + '/' + folder + '/' + slug;
  }, [selectedDomain, selectedFolder, newPageUrl]);

  useEffect(() => {
    if (slugManuallyEdited) return;
    if (!heading?.trim()) {
      setNewPageUrl('');
      return;
    }
    setNewPageUrl(slugifyHeading(heading));
  }, [heading, slugManuallyEdited, slugifyHeading]);

  useEffect(() => {
    const main = async () => {
      await fetchRequiredData(custDetails?.domain_url, testDriveDomain as string | undefined, isTestDriveUser);

      if (!isEmpty(language_country_details)) {
        const selectedLanguageDetails = {
          name: language_country_details?.language?.name,
          text: language_country_details?.language?.name,
          value: language_country_details?.language?.name,
          language_code: language_country_details?.language?.language_code,
          location_code: language_country_details?.language?.location_code,
        };
        const selectedCountryDetails = {
          name: language_country_details?.country.name,
          text: language_country_details?.country.name,
          value: language_country_details?.country.name,
          alpha_3: language_country_details?.country.alpha_3,
          alpha_2: language_country_details?.country.alpha_2,
        };
        setSelectedLanguage({ ...selectedLanguageDetails });
        setSelectedCountry({ ...selectedCountryDetails });
      }

      if (copyExistingPageData && !isUndefined(copyExistingPageData)) {
        const responseData = fetchHeadingAndUrl(copyExistingPageData, creatingPageFrom);
        if (responseData) {
          setHeading(responseData.pageHeading);
          const { folder, slug } = splitInitialPageUrl(responseData.pageUrl);
          setSelectedFolder(folder);
          setNewPageUrl(slug);
          setSlugManuallyEdited(true);
        }
      } else if (
        [
          CREATE_NEW_PAGE_USING.FROM_SEARCH_INTENTS,
          CREATE_NEW_PAGE_USING.FROM_KEYWORD_GAP,
          CREATE_NEW_PAGE_USING.GROWTH_TRENDS,
        ].includes(creatingPageFrom) &&
        discoveredKeywords
      ) {
        const heading = discoveredKeywords[0].charAt(0).toUpperCase() + discoveredKeywords[0].slice(1).toLowerCase();
        const urlEnd = discoveredKeywords[0]?.toLowerCase()?.split(' ')?.join('-')?.replace(/['"]/g, '');
        setHeading(heading);
        setNewPageUrl(urlEnd);
        setSlugManuallyEdited(true);
      }
    };

    main();
  }, []);

  useEffect(() => {
    if (router.pathname?.includes('growth-trends')) {
      setIsFromGrowthTrends(true);
    }
  }, [router.pathname]);

  const formatCountryForDropDown = useCallback((list) => {
    const newList: typeCountryData[] = list.map((ele) => {
      return { name: ele.NAME, text: ele.NAME, value: ele.NAME, alpha_3: ele.ALPHA_3, alpha_2: ele.ALPHA_2 };
    });
    setCountryDataList(newList);
  }, []);

  const formatLanguageForDropDown = useCallback((list) => {
    const newList: typeLanguageData[] = list.map((ele) => {
      return {
        name: ele.LANGUAGE_NAME,
        text: ele.LANGUAGE_NAME,
        value: ele.LANGUAGE_NAME,
        language_code: ele.LANGUAGE_CODE,
        location_code: ele.LOCATION_CODE,
        country_iso_code: ele.COUNTRY_ISO_CODE,
      };
    });
    setLanguageDataList(newList);
  }, []);

  useEffect(() => {
    if (!isEmpty(masterLanguageAndCountry)) {
      if (masterLanguageAndCountry['countryData']) {
        formatCountryForDropDown(masterLanguageAndCountry['countryData']);
      }
      if (masterLanguageAndCountry['languageData']) {
        formatLanguageForDropDown(masterLanguageAndCountry['languageData']);
      }
    }
  }, [formatCountryForDropDown, formatLanguageForDropDown, masterLanguageAndCountry]);

  const uniqueDomainDropDownList = useMemo(() => {
    // Display-only ordering: dedupe first so the existing "first entry wins" rule still
    // picks the same option, then sort purely for the dropdown. selectedDomain is resolved
    // in fetchDomains from the unsorted source, so the pre-selected domain is unchanged.
    return sortDomainOptions(uniqBy(domainAutocompleteList, 'text'));
  }, [domainAutocompleteList]);

  const uniqueLanguageDataList = useMemo(() => {
    return uniqBy(languageDataList, 'text') || [];
  }, [languageDataList]);

  const uniqueCountryDataList = useMemo(() => {
    return uniqBy(countryDataList, 'alpha_2') || [];
  }, [countryDataList]);

  const findDuplicateUrl = useCallback(async (pageUrl) => {
    try {
      setExistingPageData(null);
      const checkUrlExistOrNot = await ApiService.post(
        `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/master-data/check-url-exist`,
        {
          pageUrl,
        }
      );
      if (checkUrlExistOrNot && checkUrlExistOrNot?.existingRecord) {
        setExistingPageData(checkUrlExistOrNot?.existingRecord);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('CreateNewPageFromExistingPage:findDuplicateUrl:: error', error);
      throw error;
    }
  }, []);

  const redirectHandler = useCallback((record) => {
    // const isNewPage = record?.data_source?.includes('ORG') && record?.is_cnp === 'FALSE' ? '&newPage=true' : '';
    const isCnp = String(record?.is_cnp).toLowerCase() === 'true';
    const { params } = isCnp ? getPageDraftDetailPagePath(record) : getCRDetailPagePath('', record);
    window.open(params, '_blank');
  }, []);

  const existingUrlRedirectHandler = () => {
    redirectHandler(existingPageData);
  };

  const liveUrlValidator = async (url) => {
    try {
      const apiResponse = await ApiService.post(
        `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/recommendations/get-url-live-status`,
        {
          url: url,
        }
      );
      return apiResponse?.data?.url_details?.islive == true;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const liveUrlRedirect = () => {
    window.open(validLiveUrl);
  };

  const domainSetupRedirectHandler = () => {
    Router.push('/app/settings/setup/add-domains');
  };

  const addNewPageIntoState = useCallback(
    ({ pageURL, newPageId, dateValue = new Date(), heading, pageType: _pageType }) => {
      const data = {
        finalurl: pageURL,
        uuid: newPageId,
        content_recommendation_id: newPageId,
        page: pageURL,
        created_on: dateValue,
        updated_on: null,
        is_manual: true,
        updated_date: dateValue,
        organic_rank: 'M',
        entity_type: 'new-page',
        entity_id: newPageId,
        annotation_desc: null,
        date: dateValue,
        annotation_type: 'published',
        annotation_subtype: 'research-keywords',
        annotation_details: {},
        created_by: user?.name || user?.family_name || '',
        updated_by: null,
        isResolved: true,
        pageUpdatedInfo: {
          name: user?.name || user?.family_name || '',
          date: dateValue,
        },
        h1: heading,
        is_deleted: false,
        page_type: _pageType || 'article',
      };
      dispatch({
        type: actionTypes.SET_CONTENT_BRIEF_DATA,
        contentBriefList: [data, ...(contentBriefList || [])],
      });
    },
    [contentBriefList, dispatch, user?.family_name, user?.name]
  );

  const handleAutoGenerateSlug = useCallback(async () => {
    if (!heading?.trim()) {
      toggleSnackBar({ text: 'Please enter a Tentative H1 first', type: 'warning', open: true });
      return;
    }
    try {
      setIsGeneratingSlug(true);
      // Collect existing slugs from contentBriefList to prevent duplicates
      const existingSlugs = (contentBriefList || [])
        .map((item) => {
          try {
            const url = item?.finalurl || item?.page || '';
            if (!url) return '';
            const pathname = new URL(url).pathname;
            return (
              pathname
                .replace(/^\/+|\/+$/g, '')
                .split('/')
                .pop() || ''
            );
          } catch {
            return '';
          }
        })
        .filter(Boolean);

      // Add currently entered slug if any
      if (newPageUrl?.trim()) {
        existingSlugs.push(newPageUrl.trim());
      }

      const response = await fetchAIBasedContent({
        promptFor: 'PAGE_DRAFT.GENERATE_URL_SLUG',
        promptConfig: {
          heading: heading.trim(),
          domain: selectedDomain || '',
          existingSlugs: existingSlugs.length > 0 ? existingSlugs.join('\n') : '',
        },
        tokenLimit: 100,
      });

      if (response) {
        const slug = normalizeSlugInput(String(response).trim().replace(/['"]/g, ''));
        setNewPageUrl(slug);
        setSlugManuallyEdited(true);
      }
    } catch (error) {
      console.error('Auto-generate slug error:', error);
      toggleSnackBar({ text: 'Failed to auto-generate slug', type: 'error', open: true });
    } finally {
      setIsGeneratingSlug(false);
    }
  }, [heading, selectedDomain, contentBriefList, newPageUrl, toggleSnackBar, normalizeSlugInput]);

  const submitFormHandler = async () => {
    try {
      let isFormValid = true;
      setHeadingError('');
      setValidUrlError('');
      setCountryError('');
      setLanguageError('');
      setEditorError('');
      setKeywordsError('');
      setValidLiveUrl('');
      if (!heading || !heading.trim()) {
        isFormValid = false;
        setHeadingError('Please enter tentative H1');
      }
      const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
      if (isHTML(heading)) {
        isFormValid = false;
        setHeadingError('Please enter a valid tentative H1 or remove the html tags');
      }
      const domains = testDriveDomain ? [testDriveDomain] : [...domainsList];
      let urlSlug = newPageUrl;
      if (urlSlug.startsWith('/')) {
        isFormValid = false;
        setValidUrlError('Please remove / from the beginning of URL slug');
        return;
      }
      // Allow exactly one trailing slash (e.g. "it-and-security/").
      // Collapse any run of multiple consecutive slashes into a single slash.
      urlSlug = urlSlug.replace(/\/{2,}/g, '/');
      if (/['"]/.test(urlSlug)) {
        isFormValid = false;
        setValidUrlError('URL slug cannot contain quotes. Please remove them and try again.');
        return;
      }
      const folderPart = (selectedFolder || '/').replace(/^\/+|\/+$/g, '');
      const slugForUrl = folderPart ? `${folderPart}/${urlSlug}` : urlSlug;
      const pageURL = buildCmsPageUrl(selectedDomain, slugForUrl, pagesPath);
      //// REMOVEING #_quattr_manual_page from everywhere
      const { isValidUrl } = validateUrlWithDomains(pageURL, domains);
      if (!isValidUrl || !newPageUrl || !newPageUrl.trim()) {
        isFormValid = false;
        setValidUrlError('Please enter a valid URL slug');
      }
      if (!selectedCountry || !countryDataList.some((item) => selectedCountry.value === item.value)) {
        isFormValid = false;
        setCountryError('Please select a valid Country');
      }
      if (!selectedLanguage || !languageDataList.some((item) => selectedLanguage.value === item.value)) {
        isFormValid = false;
        setLanguageError('Please select a valid Language');
      }
      if (showEditorDropdown && !selectedEditorType) {
        isFormValid = false;
        setEditorError('Please select an editor');
      }
      if (discoveredKeywords && !keywords?.length) {
        isFormValid = false;
        setKeywordsError('Please select at least one keyword');
      }
      // Return early if synchronous validations fail
      if (!isFormValid) {
        return isFormValid;
      }
      // Show loader only after synchronous validations pass
      setIsApiInProcess(true);
      // Async validations
      if (await findDuplicateUrl(pageURL)) {
        isFormValid = false;
      }
      if (isFormValid && (await liveUrlValidator(pageURL))) {
        isFormValid = false;
        setValidLiveUrl(pageURL);
      }
      if (!isFormValid) {
        setIsApiInProcess(false);
        return isFormValid;
      } else {
        const newPageId = getUuidByString(custDetails?.cust_code?.replace('_', '') || '', pageURL);
        const dateValue = new Date();

        const finalPayloadKeywords = copyExistingPageData
          ? [
              ...(copyExistingPageData?.selectedRowDataForPageCreation?.map(
                (kwdDet) => kwdDet?.['Keyword Cluster']?.props?.clusterName || kwdDet?.['Keyword Cluster']
              ) || []),
            ]
          : keywords || [];

        trackAnalyticsEvent({
          eventFor: '',
          buttonText: '',
          eventName: `Create New Page Form Submitted`,
          payload: {
            label: `${finalPayloadKeywords.length} Keywords Selected`,
            event_name: `Create New Page Form Submitted`,
            customer_url: copyExistingPageData ? copyExistingPageData?.pageUrl : '',
            component_name: isFromGrowthTrends
              ? COMPONENT_NAMES.growth_trends
              : COMPONENT_NAMES.content_recommendations,
            screen_name: isFromGrowthTrends ? SCREEN_NAMES.growth_trends : SCREEN_NAMES.content_recommendations,
          },
        });

        const locationCodeBasedOnCountry: any = getCountryDetailsByAlpfa2(selectedCountry?.alpha_2);
        const selectedLanguageDetails: any = selectedLanguage ?? {};
        selectedLanguageDetails.location_code =
          locationCodeBasedOnCountry?.location_code ?? selectedLanguageDetails.location_code;

        const payload = {
          copyPage: copyExistingPageData?.pageUrl,
          copyId: copyExistingPageData?.pageId,
          newId: newPageId,
          newPage: pageURL,
          newHeading: heading || '',
          countryAndLanguageDetails: {
            country: { ...selectedCountry, location_code: locationCodeBasedOnCountry?.location_code },
            language: { ...selectedLanguage, location_code: locationCodeBasedOnCountry?.location_code },
          },
          country_code:
            language_country_details?.country?.alpha_3 || (language_country_details?.country?.alpha_2 as string),
          pageUrl: pageURL,
          pageId: newPageId,
          pageType,
          selectedEditorType,
          wpPostType: selectedWpPostType || 'post',
          creatingPageFrom: creatingPageFrom,
          annotationPayload: {
            recommendation_id: newPageId,
            reason: ANNOTATION_SUB_TYPE_VALUE.RESEARCH_KEYWORDS,
            date: format(new Date(dateValue), 'MM/dd/yyyy'),
            entity_type: _RESOLUTION_ENTITY_TYPE.CNP,
            entity_id: newPageId,
            annotation_type: ANNOTATION_TYPE.PUBLISHED,
            annotation_subtype: ANNOTATION_SUB_TYPE_VALUE.RESEARCH_KEYWORDS,
            annotation_details: {},
          },
          keywords: finalPayloadKeywords || [],
          subKeywords: copyExistingPageData?.selectedSubKeywordsMapping || [],
          include_serp_info: true,
          isIncluded: true,
        };
        const apiResponse = (await ApiService.post(
          `${process.env.NEXT_PUBLIC_QUATTR_API_URL}/api/contentbrief/v1/create`,
          payload
        )) as { data: typeAny };

        if (apiResponse?.data?.createdContentdata?.[0]?.page_id === newPageId) {
          addNewPageIntoState({
            pageURL: pageURL,
            newPageId: newPageId,
            dateValue: dateValue,
            heading,
            pageType,
          });
          const payload: Payload = {
            label: 'New Page Created Successfully',
            customer_url: copyExistingPageData ? copyExistingPageData.pageUrl : '',
            component_name: isFromGrowthTrends
              ? COMPONENT_NAMES.growth_trends
              : COMPONENT_NAMES.content_recommendations,
            screen_name: isFromGrowthTrends
              ? SCREEN_NAMES.growth_trends
              : existingPageData?.is_cnp
              ? SCREEN_NAMES.page_draft
              : SCREEN_NAMES.content_recommendations,
            step_name: existingPageData?.is_cnp ? '3 - Write & Improve Content' : '3 - Improve Content', // Default step_name
          };

          // Remove step_name if isFromGrowthTrends is true
          if (isFromGrowthTrends) {
            delete payload.step_name;
          }

          trackAnalyticsEvent({
            eventFor: '',
            buttonText: '',
            eventName: `New Page Created Successfully`,
            payload: payload,
          });

          if (redirectToNewTab && newPageId) {
            toggleSnackBar({
              type: 'success',
              text: 'New page draft successfully created.',
              open: true,
            });
            // Opens the link in a new tab
            const newTab = window.open(
              `${process.env.NEXT_PUBLIC_HOST_URL}/app/content-recommendations/content-brief/details/${newPageId}`,
              '_blank'
            );
            // Check if the new tab was blocked
            if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
              // If opening in a new tab failed show popup with link to click
              toggleSnackBar({
                type: 'success',
                text: 'New page draft successfully created.',
                open: false,
              });
              Router.push(
                `/app/content-recommendations/content-brief/details/[id]`,
                `/app/content-recommendations/content-brief/details/${newPageId}`
              );
              dispatch({
                type: actionTypes?.SET_CUSTOM_POPUP_STATUS,
                customPopupConfig: {
                  showPopup: true,
                  text: 'Your browser prevented a new tab from opening. Please enable pop-ups and redirects to have future pages open automatically in a new tab.',
                  // anchorText: 'Click here to open in a new tab',
                  // anchorLink: `${process.env.NEXT_PUBLIC_HOST_URL}/app/content-recommendations/content-brief/details/${newPageId}`,
                },
              });
              trackAnalyticsEvent({
                eventName: 'Shown Redirects Blocked Popup',
                payload: {
                  label: 'Shown Redirects Blocked Popup',
                },
              });
            } else if (newTab) {
              trackAnalyticsEvent({
                eventName: 'Viewed Created Page In New Tab',
                payload: {
                  label: 'Viewed Created Page In New Tab',
                },
              });
            }
          } else {
            Router.push(
              `/app/content-recommendations/content-brief/details/[id]`,
              `/app/content-recommendations/content-brief/details/${newPageId}`
            );
          }
          setShowCreateNewPagePopUp(false);
        } else {
          toggleSnackBar({
            type: 'error',
            text: 'We apologize, but a new page couldnt be created due to technical difficulties. Please retry or reach out to us for assistance.',
            open: true,
          });
        }
      }
    } catch (error: any) {
      console.error('CreateNewPageFromExistingPage::submitForm::error', error);
      if (error?.data?.data?.toUpperCase().includes('duplicate'.toUpperCase())) {
        toggleSnackBar({ type: 'error', text: 'URL already exists!!', open: true });
      } else {
        toggleSnackBar({
          type: 'error',
          text: 'We apologize, but a new page couldnt be created due to technical difficulties. Please retry or reach out to us for assistance',
          open: true,
        });
      }
    } finally {
      setIsApiInProcess(false);
    }
  };

  const onInputChangeHandler = (newInputValue: string) => {
    const options = newInputValue.split(',');
    if (options.length > 1 && keywords) {
      setKeywords(
        keywords
          .concat(options)
          .map((x) => x.trim())
          .filter((x) => x)
      );
    } else {
      setInputValue(newInputValue);
    }
  };

  return (
    <>
      <Dialog
        PaperProps={{
          style: {
            width: 720,
            maxWidth: 720,
            borderRadius: '5px',
          },
        }}
        onClose={() => {}}
        aria-labelledby="simple-dialog-title"
        className={''}
        maxWidth="md"
        open={true}
        data-testid="addNewKeywordDlgBoxWrapper"
      >
        {
          <DialogTitle className="new-keyword-dialog-title" data-testid="addNewKeywordDlgTitle">
            Enter Page Information
          </DialogTitle>
        }
        <DialogContent className={''} data-testid="addNewKeywordDlgContent">
          <div className="create-new-page-popup">
            <Grid container spacing={2} style={{ marginBottom: 16 }}>
              <Grid item xs={12} style={{ padding: '0px 8px' }}>
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button
                    variant={pageType === 'article' ? 'contained' : 'outlined'}
                    onClick={() => setPageType('article')}
                    style={{
                      flex: 1,
                      textTransform: 'none',
                      borderRadius: '0px',
                      backgroundColor: pageType === 'article' ? '#1D3557' : 'transparent',
                      color: pageType === 'article' ? '#fff' : '#1D3557',
                      borderColor: '#1D3557',
                      boxShadow: 'none',
                    }}
                  >
                    Article / Blog
                  </Button>
                  <Button
                    variant={pageType === 'landing_page' ? 'contained' : 'outlined'}
                    onClick={() => {
                      setPageType('landing_page');
                      setSelectedWpPostType('post');
                    }}
                    style={{
                      flex: 1,
                      position: 'relative',
                      textTransform: 'none',
                      borderRadius: '0px',
                      backgroundColor: pageType === 'landing_page' ? '#1D3557' : 'transparent',
                      color: pageType === 'landing_page' ? '#fff' : '#1D3557',
                      borderColor: '#1D3557',
                      boxShadow: 'none',
                    }}
                  >
                    Landing Page
                  </Button>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              style={{ alignItems: 'center', justifyContent: 'start' }}
              className="mb-12"
              data-testid="country-selection"
            >
              <Grid item xs={12} sm={12}>
                <TextField
                  label={`Tentative H1`}
                  fullWidth
                  variant="outlined"
                  value={heading}
                  onChange={(event) => {
                    setHeading(event.target.value);
                  }}
                  name="title_name"
                  error={headingError ? true : false}
                  inputProps={{ style: { borderColor: validUrlError ? 'red' : '' } }}
                />
                {headingError ? <p className="m-0 mt-5 new-page-form-error">{headingError}</p> : null}
              </Grid>
            </Grid>
            {discoveredKeywords && discoveredKeywords.length && (
              <Grid
                container
                style={{ alignItems: 'center', justifyContent: 'start' }}
                className="mt-15 mb-12"
                data-testid="country-selection"
                spacing={1}
              >
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    data-testid="new-added-chips-button"
                    multiple
                    id="multi-value"
                    options={[]}
                    value={keywords}
                    inputValue={keywordsInputValue}
                    freeSolo
                    onChange={(event, newValue) => {
                      // TODO is there anyway to validate the newValue is valid? or will it never be (string[])[] ?
                      setKeywords(newValue as string[]);
                    }}
                    onInputChange={(event, newInputValue) => {
                      onInputChangeHandler(newInputValue);
                    }}
                    ChipProps={{
                      className: 'multi-chip-setting',
                    }}
                    disableClearable={true}
                    renderInput={(params) => (
                      <>
                        <TextField
                          {...params}
                          className="multiAdd"
                          variant="outlined"
                          label={'Keywords'}
                          fullWidth
                          name="value"
                          // InputProps={{ ...params.InputProps, disableUnderline: true }}
                        />
                      </>
                    )}
                  />
                  {keywordsError ? <p className="m-0 mt-5 new-page-form-error">{keywordsError}</p> : null}
                </Grid>
              </Grid>
            )}
            <Grid
              container
              style={{ alignItems: 'center', justifyContent: 'start' }}
              className="mt-15 mb-12"
              data-testid="country-selection"
            >
              <Grid item xs={4} style={{ paddingRight: '10px' }}>
                <FormDropDown
                  className="w-100"
                  fullWidth
                  fullHeight
                  label="Select Domain"
                  options={uniqueDomainDropDownList}
                  searchable
                  searchPlaceholder="Search domain"
                  noSearchResultsText="No matching domain"
                  onChange={(res) => {
                    setSelectedDomain(res?.target?.value || '');
                    setPastedDomainNotFound(false);
                  }}
                  value={selectedDomain || ''}
                  defaultValue={selectedDomain || ''}
                />
              </Grid>
              <Grid item xs={3} style={{ paddingRight: '10px' }}>
                <FormDropDown
                  className="w-100"
                  fullWidth
                  fullHeight
                  label="Folder"
                  options={folderOptions}
                  onChange={(res) => {
                    const v = res?.target?.value || '/';
                    if (v === '__add_new_folder__') {
                      setNewFolderInput('');
                      setAddFolderError('');
                      setIsAddFolderDialogOpen(true);
                      return;
                    }
                    setSelectedFolder(v);
                  }}
                  value={selectedFolder || '/'}
                  defaultValue={selectedFolder || '/'}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  label={`Tentative URL Slug`}
                  value={newPageUrl}
                  onPaste={handleSlugPaste}
                  onChange={(event) => {
                    setNewPageUrl(normalizeSlugInput(event.target.value));
                    setSlugManuallyEdited(true);
                  }}
                  error={validUrlError || existingPageData || validLiveUrl ? true : false}
                  inputProps={{
                    style: {
                      textTransform: 'lowercase',
                      borderColor: validUrlError || existingPageData || validLiveUrl ? 'red' : '',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title={newPageUrl?.trim() ? 'Re-generate slug' : 'Auto-generate slug'} arrow>
                          <IconButton
                            onClick={handleAutoGenerateSlug}
                            disabled={isGeneratingSlug || !heading?.trim()}
                            size="small"
                            edge="end"
                            data-testid="auto-generate-slug-btn"
                          >
                            {isGeneratingSlug ? (
                              <CircularProgress size={18} />
                            ) : (
                              <MagicIcon style={{ width: 18, height: 18 }} />
                            )}
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  variant="outlined"
                  name="title_name"
                />
              </Grid>
            </Grid>
            <Grid container style={{ alignItems: 'center', justifyContent: 'start' }} className="mt-15 mb-12">
              <Grid item xs={12} sm={12}>
                <div
                  style={{
                    background: 'linear-gradient(180deg, #F4F5F7 0%, #FAFBFC 100%)',
                    border: '1px solid rgba(33,33,33,0.14)',
                    borderRadius: 0,
                    padding: '12px 14px',
                  }}
                  data-testid="page-url-preview"
                >
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 600,
                      color: '#4F4F4F',
                      marginBottom: 6,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                    }}
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
                    </svg>
                    Final URL
                  </div>
                  <div
                    style={{
                      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                      fontSize: 14,
                      color: '#3D3D3D',
                      letterSpacing: 0.2,
                      lineHeight: 1.5,
                      wordBreak: 'break-all',
                    }}
                  >
                    {fullUrlPreview || (selectedDomain ? selectedDomain : 'https://www.your-domain.com/')}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div
                  style={{
                    maxHeight: pastedDomainNotFound ? '40px' : '0',
                    opacity: pastedDomainNotFound ? 1 : 0,
                    paddingTop: pastedDomainNotFound ? '10px' : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.2s ease, opacity 0.15s ease, padding-top 0.2s ease',
                  }}
                  aria-hidden={!pastedDomainNotFound}
                  data-testid="missing-domain-note-wrap"
                >
                  <p className="m-0 missing-domain-note" data-testid="missing-domain-note">
                    Don't see your domain? Please add your domain in the{/* eslint-disable-next-line */}
                    <span className="click-here" onClick={domainSetupRedirectHandler}>
                      {' '}
                      domain setup
                    </span>
                    .
                  </p>
                </div>
              </Grid>
              {existingPageData ? (
                <p className="m-0 mt-5 new-page-form-error">
                  Page already exists
                  <span className="redirect-click-btn" onClick={existingUrlRedirectHandler}>
                    {' '}
                    click here{' '}
                  </span>
                  to view
                </p>
              ) : validUrlError ? (
                <p className="m-0 mt-5 new-page-form-error">{validUrlError}</p>
              ) : validLiveUrl ? (
                <p className="m-0 mt-5 new-page-form-error">
                  A page already exists on this domain for this URL. Provide a unique URL for your new page. To optimize
                  an existing live page, use the optimize content menu on the left.
                  <span className="redirect-click-btn" onClick={liveUrlRedirect}>
                    {' '}
                    click here{' '}
                  </span>
                  to View
                </p>
              ) : null}
            </Grid>
            <Grid container style={{ alignItems: 'flex-start', justifyContent: 'start' }} className="mt-15 mb-12">
              <Grid item xs={6} style={{ paddingRight: '10px' }} data-testid="country-selection">
                <FormAutoComplete
                  value={selectedCountry || ''}
                  options={uniqueCountryDataList}
                  label={'Select Country'}
                  className={'mb-25 w-100'}
                  onChange={(value) => {
                    setSelectedCountry(value);
                  }}
                  onTextBlur={(value) => {
                    const findCountry = uniqueCountryDataList?.find(
                      (country) => country?.text === value || country?.value === value
                    ) || {
                      forTempSolu: new Date(),
                    };
                    setSelectedCountry(findCountry as never);
                  }}
                  fullWidth
                  disableClearable
                />
                {countryError ? <p className="m-0 mt-5 new-page-form-error">{countryError}</p> : null}
              </Grid>
              <Grid item xs={6} data-testid="language-selection">
                <FormAutoComplete
                  value={selectedLanguage || ''}
                  options={uniqueLanguageDataList || []}
                  label={'Select Language'}
                  className={'mb-25 w-100'}
                  onChange={(value) => {
                    setSelectedLanguage(value);
                  }}
                  onTextBlur={(value) => {
                    const findLang = uniqueLanguageDataList?.find(
                      (lang) => lang?.text === value || lang?.value === value
                    ) || {
                      forTempSolu: new Date(),
                    };
                    setSelectedLanguage(findLang as never);
                  }}
                  fullWidth
                  disableClearable
                />
                {languageError ? <p className="m-0 mt-5 new-page-form-error">{languageError}</p> : null}
              </Grid>
            </Grid>

            <IfComponent isValid={showPostTypeDropdown}>
              <Grid container style={{ alignItems: 'center', justifyContent: 'start' }} className="mt-15 mb-12">
                <FormDropDown
                  className="w-100"
                  fullWidth
                  fullHeight
                  label="Select Post Type"
                  options={supportedPostTypeList || []}
                  onChange={(res) => {
                    setSelectedWpPostType(res?.target?.value || 'post');
                  }}
                  value={selectedWpPostType || 'post'}
                  defaultValue={selectedWpPostType || 'post'}
                />
              </Grid>
            </IfComponent>

            <IfComponent isValid={showEditorDropdown}>
              <Grid
                container
                style={{ alignItems: 'center', justifyContent: 'start' }}
                className="mt-15 mb-12"
                data-testid="editor-selection"
              >
                <FormDropDown
                  className="w-100"
                  fullWidth
                  fullHeight
                  label="Select Editor"
                  options={supportedEditorList || []}
                  onChange={(res) => {
                    setSelectedEditorType(res?.target?.value || '');
                  }}
                  value={selectedEditorType || ''}
                  defaultValue={selectedEditorType || ''}
                />
                {editorError ? <p className="m-0 mt-5 new-page-form-error">{editorError}</p> : null}
              </Grid>
            </IfComponent>

            <Grid container style={{ alignItems: 'center', justifyContent: 'start' }} className="mt-15 mb-12">
              <Grid item xs={12} sm={12} className="align-self-center">
                <div style={{ float: 'right' }}>
                  <span style={{ marginRight: '8px' }}>
                    <Button
                      className={`create-keyword-cancel-btn`}
                      variant="outlined"
                      color="primary"
                      onClick={cancelHandler}
                      style={{ marginTop: '8px' }}
                      data-testid="cancelBtn"
                    >
                      Cancel
                    </Button>
                    <Button
                      className={`create-intent-cta`}
                      variant="contained"
                      color="primary"
                      onClick={submitFormHandler}
                      style={{ marginTop: '8px', textTransform: 'capitalize', boxShadow: 'none' }}
                      data-testid="addpageBtn"
                      disabled={isApiInProcess || !selectedDomain}
                    >
                      {isApiInProcess ? <CircularProgress className="position-abs" size={20} /> : null}
                      Create New Page
                    </Button>
                  </span>
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={isAddFolderDialogOpen}
        onClose={() => setIsAddFolderDialogOpen(false)}
        PaperProps={{ style: { width: 420, maxWidth: 420, borderRadius: '5px' } }}
        data-testid="addNewFolderDlg"
      >
        <DialogTitle>Add New Folder</DialogTitle>
        <DialogContent>
          <TextField
            inputRef={newFolderInputRef}
            fullWidth
            variant="outlined"
            label="Folder name"
            placeholder="e.g. blog or /blog/"
            value={newFolderInput}
            onChange={(e) => {
              setNewFolderInput(e.target.value);
              if (addFolderError) setAddFolderError('');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddNewFolder();
              }
            }}
            error={!!addFolderError}
            helperText={addFolderError || 'A leading and trailing slash will be added automatically.'}
            inputProps={{ style: { textTransform: 'lowercase' } }}
            data-testid="newFolderInput"
          />
        </DialogContent>
        <DialogActions style={{ padding: '8px 24px 16px 24px' }}>
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            onClick={() => {
              setIsAddFolderDialogOpen(false);
              setNewFolderInput('');
              setAddFolderError('');
            }}
            style={{
              height: 36,
              padding: '0 16px',
              borderRadius: 0,
              textTransform: 'capitalize',
              boxShadow: 'none',
              boxSizing: 'border-box',
            }}
            data-testid="cancelAddFolderBtn"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={handleAddNewFolder}
            style={{
              height: 36,
              padding: '0 16px',
              borderRadius: 0,
              textTransform: 'capitalize',
              boxShadow: 'none',
              boxSizing: 'border-box',
            }}
            data-testid="confirmAddFolderBtn"
          >
            Add Folder
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(CreateNewPageFromExistingPage);
